import React, { useState } from "react";
import { auth } from "../../firebaseConfig";
import { updatePassword } from "firebase/auth";
import { Container, Box, Typography, TextField, Button, Paper } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const user = auth.currentUser;
      const storedUser = JSON.parse(localStorage.getItem("user")); 

      if (user) {
        await updatePassword(user, newPassword);
        // After successful password update, navigate to the student dashboard
        if (storedUser?.role === "admin") {
            localStorage.setItem("adminEmail", user?.email);
            localStorage.setItem("adminPassword", newPassword);
            navigate("/admin/hr-data");
          } else if (storedUser?.role === "student") {
            navigate("/student/hr-data");
          }
      } else {
        setError("User not authenticated.");
      }
    } catch (err) {
      setError("Failed to update password. Please try again.");
    }
  };

  return (
    <Container maxWidth="xs">
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={10} ml={8}>
        <Typography
          component={Link}
          to="/"
          sx={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize: "1.8rem",
            fontFamily: "'Pacifico', 'Roboto', sans-serif",
            letterSpacing: 1,
            textShadow: "2px 2px 5px rgba(0,0,0,0.2)",
            background: "linear-gradient(45deg, #ffcc00, #ff33cc)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          <CloudQueueIcon sx={{ fontSize: 40, mr: 1 }} />
          Cloud UpSkill
        </Typography>
      </Box>
      <Paper elevation={3} sx={{ padding: 4, textAlign: "center", mt: 6, borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom>
          Reset Password
        </Typography>

        <form onSubmit={handleResetPassword}>
          <TextField
            label="New Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />

          {error && <Typography color="error" variant="body2">{error}</Typography>}

          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            Update Password
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default ResetPassword;
